// var path = 'fabmedical'
var path = '..'
const medicinaModulo = {
    agGrid: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '700px'
        }
    },
    agGridHistorial: {
        paginacion: 15,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '300px'
        }
    },
    agGridReport: {
        paginacion: 10,
        id: 'myGrid',
        class: 'ag-theme-material mt-3',
        style: {
            width: '100%',
            height: '500px'
        }
    },
    url: {
        srcImagenes: {
            loguin: '../../' + path + '/assets/image/lafabril-logo-medium.svg',
            icono: '../../' + path + '/assets/image/click.png',
            estados: '../../../../assets/image/estados/',
            video: '../../' + path + '/assets/videos/video.mp4',
            tarjeta: '../../' + path + '/assets/image/avatar-dr.png',
        },
        listaSolicitada: {
            solicitadas: 'solicitadas',
            consultaEmpleado: 'consult-telemedic/', //byEmployee//1314853209
            descargar: 'diagnosis/recipe/',
            busqueda: 'diagnosis/',
        },
        medico: {
            cercoEpidemio : 'epidemiological-fence',
        },
        consulta: {
            parentesco: 'relations',
            sintomas: 'sint',
            clasificacion: 'class-consult',
            consulta: 'consult-telemedic',
            historial: 'medical-history/',
            historialDetalle: 'dispensary/find-consult/',
            aislamiento: 'employee/isolation-condition/',
            permisos: 'employee/rest',
            descargarPermisos: 'diagnosis/rest/',
            validarLogin: 'register-login'
        },
        pendientes: {
            pendientes: 'consult-telemedic',
            emergencia: 'consult-telemedic/byEmergency/',
            guardar: 'diagnosis',
            estadoRevicion: 'consult-telemedic/toRevision/', //para ver el estado y cambiar al estado revicion
            cancelaRevicion: 'consult-telemedic/toRequest/', //cancela el diagnostico y cambia el estado a pendiente
            proceso: 'consult-telemedic/inProcess'
        },
        atendidas: {
            realizadas: 'consult-telemedic/byMedic/',
            detalleRealizadas: 'consult-telemedic/withDiagnostico/'
        },
        consultaMedico: {
            colaborador: 'employee/find-colaborador/',
            guardar: 'consult-telemedic/callCenter',
            medico: 'consult-telemedic/getconsulta-calltomedic/',
            porColaborador: 'consult-telemedic/getconsulta-callcenter/'
        },
        dispensario: {
            guardarMuestra: 'dispensary',
            guardarMuestraPcr: 'dispensary/pcr',
            guaradarEnfermedades: 'diseases-pre-existing',
            colaborador: 'dispensary/find-collaborator/',
            enfermedadesPre: 'consult-telemedic/diseases-pre-existing',
            //desbloquear
            getDesbloquear: 'dispensary/positive-evaluations',
            desbloquear: 'employee/active/',
            getHistorial: 'dispensary/valoration/find-collaborator/',
            guardarExamenes: 'dispensary/valoration',
            // consult-telemedic/dummy/1310221989
            guardarDummy: 'dispensary/consult-dummy/',
            consultaCombo: 'dispensary/schedules-user/',
            vulnerabilidad: 'vulnerability/',
            //subirResultados
            subirResultado: 'dispensary/readNegativePCRAssessment',
            guardarResultado: 'dispensary/createNegativePCRAssessment',
            //dipensarioFamilia
            cedulaFamilia: 'epidemiological-fence/find-colaborador/',
            comboFamilia: 'epidemiological-fence/colaborador-family/',
            guardarExamenesFamiliares: 'epidemiological-fence/valoration-family',
            historialFamilia: 'epidemiological-fence/history-valoration-family/',
            historialFamiliaPariente: 'epidemiological-fence/history-valoration-family-forParent/',
            //descargar agendados por dispensario
            descargaAgendadosDis: 'human-resource/bluid-valoration-report',
            //consultas en ingreso de examenes
            getPermisos: 'dispensary/medical-permits/',
            getReceta: 'dispensary/medical-prescription/',
            getDispensarioHoteles: 'dispensary/hotel-accommodation/',
            guardarEstatus: 'employee/update-status',
            eliminarValoracion: 'dispensary/valoration/',
            //colaboradores
            getColaboradores: 'employee',
            //actualizarCerco
            updateCerco: 'employee/update-cerco'
        },
        americanCallCenter: {
            getAmerican: 'american-callcenter',
            agendar: 'american-callcenter',
            getFamiliares: 'epidemiological-fence/family-menbers',
            agendarFamilia: 'epidemiological-fence/family-scheduling',
            descargaAgendaFamilia: 'epidemiological-fence/build-excel-family'
        },
        mantenimiento: {
            guardarColaborador: 'maintenace/newCollaborator',
            guardarColaboradorFile: 'maintenace/newLoteCollaborator',
            empresas: 'maintenace/getfactorys',
            estadosCiviles: 'state-civil',
            editarColaborador: 'maintenace/updateCollaborator',
            eliminarColaborador: 'maintenace/deleteCollaborator/',
        },
        perfil: {
            editarPerfil: 'employee/updateProfile',
            provincias: 'localities/province',
            cantones: 'localities/canton/',
            updateAsi: 'employee/update-cod-asi?',
        },
        recursosHumanos: {
            detalleColaborador: 'human-resource',
            detalleFecha: 'human-resource/byFechaConfirmacion/',
            reporte: 'human-resource/buildReport',
            leerArchivo: 'human-resource/readDocument',
            guardarArchivo: 'human-resource/saveReadDocument',
            asistencia: 'human-resource/confirmation/',
            guardarArchivoAsistencia: 'human-resource/buildReportConfirmation',
            guardarAsistencia: 'human-resource/updat-assistance',
            getAgendaDisp: 'human-resource/valoracion-program/',
            postAgendaDisp: 'human-resource/create-from-valoration',
            //combos
            compañia: 'human-resource/company',
            dispensario: 'human-resource/dispensary',
            localidad: 'human-resource/location',
            departamentos: 'human-resource/departments',
            busqudaFiltro: 'human-resource/filter',
            guardarNext: 'human-resource/edit-next-valoration',
        },
        reporteria: {
            //reporte1
            cargos: 'reporte/lista-cargos',
            areas: 'reporte/lista-areas',
            getInscrito: 'reporte/find-inscrito',
            descargaInscrito: 'reporte/rep-inscrito',
            valoracionPersonal: 'report-encuesta/',
            periodoSemana: 'periodo-semana',
            reportEncuesta: 'report-encuesta/semana/',
            reportDesEncuesta: 'report-encuesta/semanaExcel/'
            //http://172.25.4.5:8001/fabmedical/v1/api/services/report-encuesta/semanaExcel/2022-13/0908171531
            //http://172.25.4.5:8001/fabmedical/v1/api/services/report-encuesta/semana/2022-13/0908171531
            // http://172.25.4.5:8001/fabmedical/v1/api/services/report-encuesta/2021-01-09/1307774016
        },
        administrador: {
            usuarios: 'administrator/usersActived',
            roles: 'administrator/roles',
            addRoles: 'administrator/addAuthority',
            deleteRoles: 'administrator/deleteAuthority',
            createUser: 'administrator/newUser',
            localidad: 'administrator/localities',
            dispensario: 'dispensario_medico',
            doctor: 'doctor'
        },
        bienestarSocial: {
            aislamiento: 'aislamiento/',
            aislamientoPendiente: 'aislamiento/pendiente',
            aceptarAislamiento: 'aislamiento/acepta', //   /{cedColaborador}/{cedAprueba}
            registrarHotel: 'hotel/',
            hotelesDisponible: 'hotel/disponible',
            checkIn: 'aislamiento/checkIn/',
            checkOut: 'aislamiento/checkOut/',
            exportExcel: 'aislamiento/export',
            report: 'aislamiento/report'

        },
        sstma: {
            reportTerminos: 'reporte/term-cond'
        },
        garita: 'acces-plant/',
        listas: 'listas',
        confirmacion: 'acces-plant-local/',
        roles: 'employee/find-authoritys/',
        sessionTime: 'register-login',
    },
    button: {
        buttonsCss: {
            primary: 'btn btn-primary btn-block',
            secondary: 'btn btn-secondary btn-block',
            success: 'btn btn-success btn-block',
            danger: 'btn btn-danger btn-block',
            warning: 'btn btn-warning btn-block',
            info: 'btn btn-info btn-block',
            light: 'btn btn-light btn-block',
            dark: 'btn btn-dark btn-block',
            primaryOutline: 'btn btn-outline-primary',
            secondaryOutline: 'btn btn-outline-secondary',
            successOutline: 'btn btn-outline-success',
            dangerOutline: 'btn btn-outline-danger',
            warningOutline: 'btn btn-outline-warning',
            infoOutline: 'btn btn-outline-info',
            lightOutline: 'btn btn-outline-light',
            darkOutline: 'btn btn-outline-dark',
            primarylg: 'btn btn-primary btn-lg btn-block',
            successLg: 'btn btn-success btn-lg btn-block',
            dangerLg: 'btn btn-outline-danger btn-lg btn-block',
            warningLg: 'btn btn-warning btn-lg btn-block',
            warningLgFile: 'btn btn-warning btn-lg btn-block btn-file',
        },
        buttonsNombre: {
            editar: 'Editar',
            ver: 'Ver',
            eliminar: 'Eliminar',
            agregar: 'Agregar ',
            guardar: 'Guardar',
            actualizar: 'Actualizar',
            mostrar: 'Mostrar seleccion',
            regresar: 'Regresar',
            continuar: 'Continuar',
            seleccionar: 'Seleccionar',
            procesar: 'Procesar',
            sustento: 'Sustento',
            validar: 'Validar',
            descargar: 'Descargar',
            descargarRecibo: 'Descargar Recibo Cobros',
            descargarEstado: 'Descargar Estados Docs',
            //dispensario
            ingresoMuestras: 'INGRESO DE RESULTADOS DE MUESTRAS IGM - IGG',
            ingresoResultado: 'INGRESO DE RESULTADOS',
            ingresoFamilia: 'INGRESO DE RESULTADOS DE FAMILIARES',
            atenderCitas: 'ATENDER CITAS (ENFERMEDADES PRE-EXISTENTES)',
            desbloqueaRegistros: 'DESBLOQUEAR REGISTROS ERRONEOS',
            seguimiento: 'SEGUIMIENTO COLABORADORES CUARENTENA',
            crearColaborador: 'CREAR COLABORADOR',
            //formularios dispensario
            enviar: 'Enviar',
            atender: 'Atender',
            aceptar: 'Aceptar',
            desbloquearColaborador: 'Desbloquear Colaborador',
            desbloquearVulnerabilidad: 'Desbloquear Vulnerabilidad',
            regresar: 'Regresar',
            cancelar: 'Cancelar',
            //desbloquear
            desbloquear: 'Desbloquear',
            cuarentena: 'Cuarentena',
            //american callcenter
            agendarColaborador: 'Colaboradores por agendar',
            agendarFamiliares: 'Familiares en cerco por agendar',
            reporteCitas: 'Reporte de citas',
            agendar: 'Agendar',
            //bienestar
            condiciones: 'Condiciones Cuarentena',
            asignarHotel: 'Asignar Hotel',
            checkOut: 'Check Out',
        }
    },
    mensajes: {
        errorServicio: 'error..!!',
        desabilitada: 'Opción desabilitada',
        eliminar: '¿Esta seguro que desea eliminar el siguiente elemento?',
        guardar: '¿Esta seguro que desea guardar el siguiente elemento?',
        actualizar: '¿Esta seguro que desea actualizar el siguiente elemento?',
        datoGuardado: 'Se guardo corectamente..!!',
        guardarParada: 'Esta seguro que desea registrar este evento..??',
        procesar: '¿Esta seguro que desea procesar el siguiente elemento?',
        validar: '¿Esta seguro que desea validar el siguiente elemento?',
        anticipo: 'Se tomara este valor como anticipo.',
        camposObligatorio: 'Los campos tipo transaccion y número documento deben estar llenos caso contrario se tomara como anticipo.',
        //dispensario
        colaboradorOk: 'El colaborador tiene una consulta disponible.',
        colaboradorError: 'El colaborador no tiene una consulta disponible.',
        enviar: '¿Esta seguro que desea enviar los siguientes datos?',
        ingresoCedula: 'Debe ingresar una cedula.',
        //desbloquear
        desbloquearMsn: 'El estado de la consulta ha cambiado a "Desbloqueado".',
        desbloquear: 'Esta seguro que desea desbloquear la siguiente consulta?',
        //cuarentena
        cuarentena: 'Esta seguro que desea aceptar la cuarentena?',
        cuarentenaMsn: 'Usted a aceptado la cuarentena.',
        cancelarCuarentena: 'Esta seguro que desea rechazar la cuarentena?',
        cancelarCuarentenaMsn: 'Usted a rechazado la cuarentena.',
        //american callcenter
        agendar: 'Esta seguro que desea agendar la siguiente consulta?',
        agendarMsn: 'Usted a agendado la consulta.',
    },
    titulos: {
        //dispesario
        enfermedadesPre: 'Lista de Colaboradores con enfermedades pre-exisentes',
        listaConsultas: 'Lista de Consultas',
        //american callcenter
        listaAgendar: 'Lista de colaboradores por agendar'
    }

}


export { medicinaModulo }